import * as React from "react";
import Image from "../imgs/icons/fussball_de.svg";
import SvgIcon from "./SvgIcon";

const FussballDeIcon = () => {
  return <SvgIcon svg={Image} />
}
export default FussballDeIcon;